import { Injectable } from '@angular/core';
import { appVersion } from './bugsnag-client';

@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  version = appVersion;
}
